"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageIdPathParamsSchema = void 0;
const zod_1 = require("zod");
exports.LanguageIdPathParamsSchema = zod_1.z.object({ languageId: zod_1.z.string().uuid() });
